import { createFileRoute, notFound } from "@tanstack/react-router";
import shopStyles from "../styles/shop.css?url";
import { CartPage } from "../components/shop/cart-page";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadCart } from "../server/shop";

/** The bag (/merch/cart): read from the buyer's browser, never from the server. */
export const Route = createFileRoute("/merch/cart")({
  loader: async () => {
    const cart = await loadCart();
    if (!cart) throw notFound();
    return cart;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/merch/cart",
        title: `Your bag | ${shell.creator.name}`,
        description: shell.creator.description,
        noindex: true,
      }),
      shopStyles,
    );
  },
  component: Cart,
});

function Cart() {
  return <CartPage cart={Route.useLoaderData()} />;
}
